/** Follows one run live over its event stream (watchEvents has the reconnect and polling rules). */
import { RunSnapshot } from '../domain/schemas'
import { watchEvents, type WatchEventsOptions } from './watchEvents'

export { backoff, type WatchState } from './watchEvents'

export interface WatchOptions extends Omit<WatchEventsOptions<RunSnapshot>, 'onEvent' | 'onPoll'> {
  onRun: (run: RunSnapshot) => void
}

export function watchRun({ onRun, ...o }: WatchOptions): { stop: () => void; done: Promise<void> } {
  return watchEvents({
    ...o,
    onPoll: onRun,
    onEvent: (ev) => {
      if (ev.event !== 'run') return
      const parsed = RunSnapshot.safeParse(JSON.parse(ev.data))
      if (parsed.success) onRun(parsed.data)
    },
  })
}
